<template>
  <div class="custom-container" v-loading.fullscreen.lock="retur.isLoading">
    <el-container class="category-title my-2"
      >Retur Details &nbsp; <b> {{ retur.data.returId }} </b>
    </el-container>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" shadow="never">
          <el-row type="flex" justify="space-between" align="middle">
            <el-col>
              <el-tag
                v-if="retur.data.returStatus === 'payment_confirmation'"
                type="dark"
                effect="dark"
                >Menunggu Pembayaran</el-tag
              >
              <el-tag
                v-else-if="retur.data.returStatus === 'pending'"
                type="danger"
                effect="dark"
                >Tertunda</el-tag
              >
              <el-tag
                v-else-if="retur.data.returStatus === 'on_progress'"
                type="info"
                effect="dark"
                >Dalam Proses</el-tag
              >
              <el-tag
                v-else-if="retur.data.returStatus === 'delivery'"
                type="warning"
                effect="dark"
                >Dalam Pengiriman</el-tag
              >
              <el-tag
                v-else-if="retur.data.returStatus === 'approved'"
                type="success"
                effect="dark"
                >Selesai</el-tag
              >
              <el-tag type="dark" effect="dark">{{
                retur.data.branchCodeData
              }}</el-tag>
            </el-col>

            <el-col>
              <el-row type="flex" justify="end">
                <el-button
                  type="primary"
                  size="small"
                  @click="
                    $router.push({
                      name: 'print-retur-detail',
                      params: {
                        returDetail: retur.data,
                      },
                    })
                  "
                  >Print Out</el-button
                >
                <el-tag v-if="retur.data.returCreatedAt">
                  {{ retur.data.returCreatedAt }}
                </el-tag>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-4">
      <el-col :lg="24" :md="24">
        <el-card class="box-card mb-2" shadow="never">
          <span style="font-size: 16px; font-weight: bold">Items Retur</span>
          <el-table :data="retur.data.orderDetail" border>
            <el-table-column
              type="index"
              label="No"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="itemName"
              label="Item"
              header-align="center"
            ></el-table-column>
            <el-table-column
              align="right"
              header-align="center"
              prop="itemPrice"
              label="Price"
              width="130"
            ></el-table-column>
            <el-table-column
              prop="qty"
              label="Qty"
              width="50"
              header-align="center"
              align="right"
            ></el-table-column>
            <el-table-column
              width="130"
              align="right"
              header-align="left"
              prop="uomCode"
              label="UOM"
            ></el-table-column
            ><el-table-column
              width="130"
              align="right"
              header-align="left"
              prop="total"
              label="Total"
            ></el-table-column>
            <el-table-column
              prop="reason"
              label="Alasan"
              header-align="center"
              align="left"
            ></el-table-column>
          </el-table>
          <el-row class="mt-4">
            <el-col :span="17" style="text-align: right">Sub Total :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ retur.data.subTotal }}
            </el-col>
          </el-row>
          <el-row v-if="retur.data.titlePromoCart !== '-'">
            <el-col :span="17" style="text-align: right"
              >{{ retur.data.titlePromoCart }} :</el-col
            >
            <el-col :span="7" style="text-align: right">
              {{ retur.data.totalPromoCart }}
            </el-col>
          </el-row>
          <el-row v-if="retur.data.titlePromoPaymentMethod !== '-'">
            <el-col :span="17" style="text-align: right"
              >{{ retur.data.titlePromoPaymentMethod }} :</el-col
            >
            <el-col :span="7" style="text-align: right">
              {{ retur.data.totalPromoPaymentMethod }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="17" style="text-align: right"
              >Sub Total Setelah Promo :</el-col
            >
            <el-col :span="7" style="text-align: right">
              {{ retur.data.subTotalAfterPromo }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="17" style="text-align: right">Tax Rate :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ retur.data.taxRate }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="17" style="text-align: right">Total :</el-col>
            <el-col :span="7" style="text-align: right">
              {{ retur.data.total }}
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-4">
      <el-col :lg="12" :md="12">
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold"
              >Shipping Address</span
            >
          </el-row>
          <el-row v-if="retur.data.ship_to">
            <template v-for="(value, name, index) in shippingAddress">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{ retur.data.ship_to[name] || "-" }}
              </el-col>
            </template>
          </el-row>
        </el-card>
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold">Shipping</span>
          </el-row>
          <el-row>
            <template v-for="(value, name, index) in shipping">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{ retur.data.shipping && retur.data.shipping[name] }}
              </el-col>
            </template>
          </el-row>
        </el-card>
      </el-col>

      <el-col :lg="12" :md="12">
        <el-card shadow="never" class="mb-2">
          <el-row type="flex" justify="end">
            <el-button
              @click="save"
              :disabled="retur.data.returStatus === 'done'"
              size="small"
              type="primary"
              >Update Status Retur</el-button
            >
          </el-row>
        </el-card>

        <el-col :lg="12" :md="12">
          <el-card
            v-if="
              retur.data.paymentCode &&
              retur.data.paymentCode.substring(0, 3) === 'COD'
            "
            class="mb-2"
            shadow="never"
          >
            <el-row class="mb-2">
              <span style="font-size: 16px; font-weight: bold">QR Code</span>
            </el-row>
            <el-row style="width: 100%">
              <el-row v-if="!conditionQr">
                <el-col>
                  <el-card class="qrCodeNotAvailable" shadow="never">{{
                    qrCode.data
                  }}</el-card>
                </el-col>
              </el-row>
              <el-row v-else>
                <img
                  v-if="blur"
                  src="../../assets/blurQr.png"
                  style="width: 350px; height: 350px"
                />
                <qr-code
                  v-else-if="!blur"
                  :text="qrCode.data"
                  :size="350"
                ></qr-code>
              </el-row>
              <el-button
                @click="getQr('COD')"
                class="mt-4"
                type="primary"
                size="small"
                style="width: 350px"
                :loading="qrCode.isLoading"
                :disabled="disabledBtnQr"
              >
                {{
                  conditionBtn === "view" ? "View Qr Code" : "Reload Qr Code"
                }}
              </el-button>
            </el-row>
          </el-card>
          <el-card
            v-if="
              retur.data.paymentCode &&
              retur.data.paymentCode.substring(0, 3) === 'TOP'
            "
            class="mb-2"
            shadow="never"
          >
            <el-row class="mb-2">
              <span style="font-size: 16px; font-weight: bold">QR Code</span>
            </el-row>
            <el-row style="width: 100%">
              <el-row v-if="!conditionQr">
                <el-col>
                  <el-card class="qrCodeNotAvailable" shadow="never">{{
                    qrCode.data
                  }}</el-card>
                </el-col>
              </el-row>
              <el-row v-else>
                <img
                  v-if="blur"
                  src="../../assets/blurQr.png"
                  style="width: 350px; height: 350px"
                />
                <qr-code
                  v-else-if="!blur"
                  :text="qrCode.data"
                  :size="350"
                ></qr-code>
              </el-row>
              <el-button
                @click="getQr('TOP')"
                class="mt-4"
                type="primary"
                size="small"
                style="width: 350px"
                :loading="qrCode.isLoading"
                :disabled="disabledBtnQr"
              >
                {{
                  conditionBtn === "view" ? "View Qr Code" : "Reload Qr Code"
                }}
              </el-button>
            </el-row>
          </el-card>
        </el-col>

        <el-card shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold">Photos</span>
          </el-row>
          <el-row>
            <img
              v-for="i in retur.data.photos"
              :key="i"
              :src="i"
              width="100"
              class="mr-3"
            />
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["oracleCustomerId", "returId"],
  components: {},
  data: () => ({
    blur: true,
    conditionBtn: "view",
    conditionQr: true,
    disabledBtnQr: false,
    formReturs: {
      paymentValue: "",
      paymentNote: "",
      attachment: "",
    },
    valid: true,
    itemsStatus: [
      { label: "Waiting for Payment", value: 0 },
      { label: "Pending", value: 1 },
      { label: "Shipping", value: 2 },
      { label: "Delivered", value: 3 },
      { label: "Rejected", value: 4 },
    ],
    image: null,
    shippingAddress: {
      country: "Country",
      province: "Province",
      city: "City",
      state: "State",
      address: "Address",
      postal_code: "Postal Code",
      phone_number: "Phone Number",
      contact_person: "Contact Person",
      contact_phone_number: "CP Contact",
    },
    billAddress: {
      country: "Country",
      province: "Province",
      city: "City",
      state: "State",
      address: "Address",
      postal_code: "Postal Code",
      phone_number: "Phone Number",
      contact_person: "Contact Person",
      contact_phone_number: "CP Contact",
    },
    shipping: {
      estimateArrival: "Estimate Arrival",
      status: "Status",
    },
    branch: "development",
  }),
  computed: {
    ...mapState({
      retur: (state) => state.retur.retur,
      qrCode: (state) => state.retur.qrCode,
    }),
  },
  methods: {
    ...mapActions({
      getRetur: "retur/GetRetur",
      updateRetur: "retur/UpdateRetur",
      getQrCode: "retur/GetQrCode",
    }),
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.image = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.formReturs.attachment = files["0"];
    },
    save() {
      const payload = {
        returId: this.retur.data.returId,
      };
      this.updateRetur(payload);
      this.snackbar = true;
    },
    getQr(type) {
      const body = {
        returId: this.retur.data.returId,
        type: type,
      };
      this.getQrCode(body);
    },
  },
  watch: {
    qrCode: {
      handler(newValue) {
        if (!newValue.isLoading && !newValue.error) {
          this.blur = false;
          this.disabledBtnQr = true;
          if (newValue.data === "QR not available") {
            this.conditionQr = false;
          } else {
            this.conditionQr = true;
          }
          const self = this;
          setTimeout(() => {
            self.blur = true;
            self.conditionBtn = "reload";
            self.disabledBtnQr = false;
          }, 5000);
        }
      },
      deep: true,
    },
  },
  created() {
    const params = {
      oracleCustomerId: this.oracleCustomerId,
      returId: this.returId,
    };
    this.getRetur(params);
    this.branch = process.env.VUE_APP_BRANCH;
  },
};
</script>

<style>
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
.qrCodeNotAvailable {
  width: 350px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: bold;
}
</style>
